<form class="filter" #formElement [formGroup]="form">
    <mat-form-field class="medium-width">
        <input type="number" matInput placeholder="Número de prefactura" formControlName="numberPreBill">
    </mat-form-field>

    <mat-form-field class="medium-width">
        <input type="text" matInput placeholder="Código cliente" formControlName="clientCode">
    </mat-form-field>

    <mat-form-field class="full-width">
        <input type="text" #client matInput placeholder="Cliente" formControlName="client" [matAutocomplete]="autClient">
        <mat-autocomplete #autClient="matAutocomplete" [displayWith]="filterCompleteClients.displayFn">
            <mat-option *ngFor="let client of filteredClientsOptions | async" [value]="client">
                {{ client.Name }}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>

    <mat-form-field class="medium-width margin-right-small">
        <input matInput autocomplete="off" formControlName="from" [matDatepicker]="pickerFrom" placeholder="Fecha prefactura desde">
        <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
        <mat-datepicker #pickerFrom></mat-datepicker>
    </mat-form-field>

    <mat-form-field class="medium-width">
        <input matInput autocomplete="off" formControlName="to" [matDatepicker]="pickerTo" placeholder="Fecha prefactura hasta">
        <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
        <mat-datepicker #pickerTo></mat-datepicker>
    </mat-form-field>

</form>